import { IconWifiOff } from './Icon';
import { cacheAgeLabel } from '../lib/time';
import { useOnline } from '../lib/online';

/**
 * Quiet, persistent, and it says when the thing on screen was true — which is
 * the only question a guest actually has when the wifi has gone.
 */
export default function OfflinePill({ fetchedAt }: { fetchedAt?: number | null }) {
  const online = useOnline();
  if (online) return null;
  return (
    <div className="pill" role="status">
      <IconWifiOff size={14} />
      {fetchedAt ? `Offline — showing the schedule ${cacheAgeLabel(fetchedAt)}` : 'Offline — showing what we had'}
    </div>
  );
}
